export class SignInError extends Error {}
export class SignInInitError extends Error {}
export class SignInUserInterruptError extends Error {}
export class SignInProviderNotSupportedError extends Error {}
export class SignInMissingClientIdError extends Error {}

export class WebAuthnSignInRetrievePublicKeyError extends Error {}

export class SignUpProviderNotSupportedError extends Error {}

export class InitError extends Error {}

export class ListError extends Error {}
